export default function TableWrapperHoc({children, style}) {
	return (
		<main className="flex flex-1 overflow-y-auto" style={style}>
			<div className="w-full max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 overflow-x-hidden">
				<div className="h-full lg:px-4 lg:py-4 sm:px-0">{children}</div>
			</div>
		</main>
	);
}
